"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var checkboxStyles = makeStyles_1.default(function (_a) {
    var typography = _a.typography, palette = _a.palette;
    return ({
        root: {
            '&:hover': {
                backgroundColor: 'transparent',
            },
            width: '40px',
            height: '40px',
        },
        labelRoot: {
            padding: '10px',
        },
        label: {
            fontSize: typography.fontMD,
            '& a': {
                color: palette.primary.main,
                textDecoration: 'none',
            },
        },
        messageDisagree: {
            display: 'block',
            fontSize: typography.fontMD,
            color: palette.error.main,
            textAlign: 'center',
            minHeight: '16px',
            width: '100%',
        },
        formControlContainer: {
            alignItems: 'center',
            display: 'inline-flex',
            padding: '10px 10px 10px 0',
            marginRight: '15px',
            width: '100%',
        },
        disclaimer: {
            '& span': {
                fontWeight: 'bold',
            },
        },
        note: {},
    });
}, { name: 'Checkout_Checkbox' });
exports.default = checkboxStyles;
